import { render } from "./index.vue?vue&type=template&id=4106c55e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4106c55e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4106c55e"],['__file',"src/components/BaseComment/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4106c55e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4106c55e', __exports__)) {
    api.reload('4106c55e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4106c55e&scoped=true", () => {
    api.rerender('4106c55e', render)
  })

}


export default __exports__